export const securedLoanProcessId = "9e777f63-742a-4200-b671-ddd228a8a277";
export const subordinatedLoanProcessId = "01a2bd62-6a85-480a-9db2-f7e2f018948f";
export const legacyProcessId = "ddd277f5-c960-4203-8c1f-caab806a9a87";
export const legacyLegacyProcessId = "8d301253-0e74-4222-a53f-d9724d51bef4";
export const subordinatedLoanUnter100ProcessId = "c04bed93-af75-41c2-b0b8-f5d6e9477b00";
export const genussRechtProcessId = "af75d9e7-31d4-4afe-b41d-d1e06f286646";
